// extracted by css-extract-rspack-plugin
export default {"Box":"use-issue-type-editor-module__Box__ikqwZ","Box_1":"use-issue-type-editor-module__Box_1__HvPlO","ColorDecorator":"use-issue-type-editor-module__ColorDecorator__NdAsj"};